<template>
  <li :class="['dropdown', 'notification', colorClass]">
    <a v-on:click="openView" class="dropdown-toggle" data-toggle="dropdown">
      <div class="icon"><i :class="['fa', iconClass]" aria-hidden="true"></i></div>
      <div class="title">{{ title }}</div>
      <div v-if="counter" class="count">{{ counter }}</div>
    </a>
    <div class="dropdown-menu">
      <ul>
        <li class="dropdown-header">{{ title }}</li>
        <li v-for="(item, index) in list">
          <a :href="item.href" v-on:click="item.onclick">
            <span v-if="item.count" class="badge badge-info pull-right">{{ item.count }}</span>
            <span v-if="item.badge" class="pull-right" v-html="item.badge"></span>
            <div class="message">
              <div class="content">
                <div class="title">{{ item.title }}</div>
                <div v-if="item.description" class="description">{{ item.description }}</div>
              </div>
            </div>
          </a>
        </li>
        <li v-if="list.length == 0" class="dropdown-empty">No items</li>
        <li class="dropdown-footer">
          <a v-on:click="openView">{{ $t('Common.showAll') }} <i class="fa fa-angle-right" aria-hidden="true"></i></a>
        </li>
      </ul>
    </div>
  </li>
</template>
<script>

export default {
  props: {
    colorClass: {
      type: String
    },
    title: {
      type: String
    },
    counter: {
      type: Number
    },
    icon: {
      type: String
    },
    view: {
      type: String
    },
    list: {
      type: Array,
      default () {
        return [];
      }
    }
  },
  computed: {
    iconClass() {
      return (typeof this.icon == 'undefined') ? 'fa-car' : 'fa-' + this.icon;
    }
  },
  methods: {
    openView() {
      this.$parent.openView(this.view);
    }
  }
}
</script>
